var chunkMapping = {
	"579": [
		883,
		2807,
		5065,
		5163,
		8731,
		9536,
		9869
	],
	"977": [
		6977
	]
};
var idToExternalAndNameMapping = {
	"883": [
		"default",
		"./clients",
		7782
	],
	"2807": [
		"default",
		"./pages",
		7782
	],
	"5065": [
		"default",
		"./components",
		7782
	],
	"5163": [
		"default",
		"./hooks",
		7782
	],
	"6977": [
		"default",
		"./App",
		1182
	],
	"8731": [
		"default",
		"./identity",
		7782
	],
	"9536": [
		"default",
		"./helpers",
		7782
	],
	"9869": [
		"default",
		"./i18n",
		7782
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}